import React from 'react';

export const TileSlide = ({ imgURL }) => {
  return (
    <div className="each-slide-effect-2">
        <div style={{ 'backgroundImage': `url(${imgURL})` }}></div>
    </div>
  )
}
